import colors from 'styles/theme/colors';

export default function GroupIcon({
  width = 12,
  height = 12,
  color = colors.black100,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath='url(#clip0_3105_120509)'>
        <path
          d='M6 0C3.65333 0 1.2 1.77391 1.2 4.69565C1.2 7.46087 5.46667 11.687 5.62667 11.8435C5.73333 11.9478 5.84 12 6 12C6.16 12 6.26667 11.9478 6.37333 11.8435C6.53333 11.687 10.8 7.46087 10.8 4.69565C10.8 1.77391 8.34667 0 6 0ZM6 6.26087C5.09333 6.26087 4.4 5.58261 4.4 4.69565C4.4 3.8087 5.09333 3.13043 6 3.13043C6.90667 3.13043 7.6 3.8087 7.6 4.69565C7.6 5.58261 6.90667 6.26087 6 6.26087Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_3105_120509'>
          <rect width='12' height='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
